import { call, takeLatest, put } from 'redux-saga/effects'
import { actionTypes, setFoodGroup } from '../actions/foodActions'
import { sendRequest } from '../services/apiService'
import { setLoadingInit } from '../actions/appActions'
import apiConfig from '../constants/apiConfig'

function* _getFoodGroup({ payload: { params, onDone } }) {
    try {
        yield put(setLoadingInit(true))
        const response = yield call(
            sendRequest,
            {
                ...apiConfig.foodGroup.list,
                path: `${apiConfig.foodGroup.list.path}`,
            },
            {}
        )

        const { responseData, success } = response
        if (success && responseData.data) {
            yield put(setFoodGroup(responseData.data))
        }
        onDone && onDone(response)
    } catch (error) {
    } finally {
        yield put(setLoadingInit(false))
    }
}

const sagas = [takeLatest(actionTypes.GET_FOOD_GROUP, _getFoodGroup)]

export default sagas
